import { render } from "./bill-delete-invoice-modal.vue?vue&type=template&id=3c6e3240"
import script from "./bill-delete-invoice-modal.vue?vue&type=script&lang=js"
export * from "./bill-delete-invoice-modal.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__